import ifmTool from '@/utils/ifmTool'
const App = {
    getScanResult: function() {
        window.native && window.native.getScanResult();
        return new Promise((resolve) => {
            window.nativeCallback.getScanResult = (data) => {
                resolve(data);
            }
        });
    },
    getGameInfo: function(gameID) {
        window.native && window.native.getGameInfo(gameID);
        return new Promise((resolve) => {
            window.nativeCallback.getGameInfo = (data) => {
                var jsonData = JSON.parse(data);
                if (jsonData.game_id != 1000) {
                    ifmTool.postAndroidGameInfo(data);
                }
                resolve(data);
            }
        });
    },
    openURL: function(url) {
        window.native && window.native.openURL(url);
    },
    download: function(gameID, url, version) {
        window.native && window.native.download(JSON.stringify({
            game_id: gameID,
            download_url: url,
            version: version
        }));
        window.nativeCallback.download = function(data) {
            if (typeof window.BSCallback.download == "function") {
                window.BSCallback.download(data)
            }
        }
    },
    getAppInfo: function() {
        window.native && window.native.getAppInfo();
        return new Promise((resolve) => {
            window.nativeCallback.getAppInfo = (data) => {
                resolve(data);
            }
        });
    },
    setData: function(key, value) {
        window.native && window.native.setData(key, value);
    },
    removeData: function(key) {
        window.native && window.native.removeData(key);
    },
    getData: function(key) {
        window.native && window.native.getData(key);
        return new Promise((resolve) => {
            window.nativeCallback.getData = (data) => {
                const jsonData = JSON.parse(data);
                if (jsonData.key == key) {
                    resolve(jsonData.value);
                }
            }
        });
    }
}

export default App;